export default __webpack_public_path__ + "static/media/physics.29dae966.svg";